import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getQuery } from '@/utils/util';
if (getQuery().vconsole && !window.vConsole) {
  import( /* webpackChunkName: "vconsole" */'vconsole').then(function (res) {
    var VConsole = res.default;
    new VConsole();
  });
}